import { Route, Routes } from "react-router-dom";
import WorkflowList from "./WorkFlowList";
import WorkflowUI from "./WorkflowUI";

const WorkFlowRoutes = () => {
    return <>
        <Routes>
            <Route path="/" element={<WorkflowList />} />
            <Route path="work-flow-ui/:id" element={<WorkflowUI />} />
        </Routes>
    </>
}

export default WorkFlowRoutes;